import { isMobile } from 'is-mobile';

export const getDevicePlatform = () => (isMobile() ? 'mobile-web' : 'web');
